import {Fill, Stroke, Style} from 'ol/style';
import {GeoJSON, TopoJSON} from 'ol/format';
import {OSM, Vector as VectorSource} from 'ol/source';
import {Tile, Vector as VectorLayer} from 'ol/layer';
import {View} from 'ol';

import env from './env.config.json';
import i18n from './translations.json';

function getHostname() {
  const url = window.location.href;
  const urlArr = url.split('/');
  const domain = urlArr[2];
  return urlArr[0] + '//' + domain;
}

export const DEFAULT_OPACITY = 0.7;

export const perc2color = (perc: number): string => {
  perc = perc * 100;
  let r;
  let g;
  const b = 0;
  if (perc < 50) {
    r = 255;
    g = Math.round(5.1 * perc);
  } else {
    g = 255;
    r = Math.round(510 - 5.1 * perc);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const h = r * 0x10000 + g * 0x100 + b * 0x1;
  return `rgba(${r}, ${g}, ${b}, 1)`;
};

export const decimal2prettyPerc = (x) => {
  return `${(x * 100).toFixed(2)}&nbsp;%`;
};

const indexStyle = (feature) => {
  if (isNaN(feature.get('aggregate'))) {
    return [
      new Style({
        fill: new Fill({
          color: '#FFF',
        }),
        stroke: new Stroke({
          color: '#3399CC',
          width: 0.25,
        }),
      }),
    ];
  } else {
    return [
      new Style({
        fill: new Fill({
          color: perc2color(feature.get('aggregate')),
        }),
        stroke: new Stroke({
          color: '#FFFFFF',
          width: 0.15,
        }),
      }),
    ];
  }
};

export const nuts2style = new Style({
  stroke: new Stroke({
    color: '#000000',
    width: 0.5,
  }),
});

export const nuts2Layer = new VectorLayer({
  properties: {
    title: 'NUTS2 regions',
    editor: {editable: false},
    editable: false,
    queryable: false,
  },
  source: new VectorSource({
    //features: new GeoJSON().readFeatures(nuts2),
    format: new GeoJSON(),
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    url: require('./data/NUTS_RG_20M_2016_3857_LEVL_2.geojson').default,
    overlaps: false,
  }),
  visible: false,
  style: nuts2style,
});

export const nuts3IndexSource = new VectorSource({
  //features: new GeoJSON().readFeatures(nuts3),
  format: new TopoJSON({dataProjection: 'EPSG:3857'}),
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  url: require('./data/NUTS_RG_20M_2016_3857_LEVL_3.topojson').default,
  overlaps: false,
});

export const nuts3IndexLayer = new VectorLayer({
  properties: {
    title: 'NUTS3 regions: Rural attractiveness index',
    editor: {editable: false},
    autoLegend: false,
    //queryable: false,
    popUp: {
      attributes: [
        {
          attribute: 'aggregate',
          label: 'aggregated',
          //displayFunction: decimal2prettyPerc,
        },
      ],
    },
  },
  source: nuts3IndexSource,
  opacity: DEFAULT_OPACITY,
  visible: true,
  style: indexStyle,
});
/*nuts3IndexLayer.set('popUp', {
  attributes: [
    {
      attribute: 'aggregate',
      label: 'aggregated',
      displayFunction: decimal2prettyPerc,
    },
  ],
});*/

export const AppConfig = {
  assetsPath: 'assets/hslayers-ng',
  useProxy: false,
  //proxyPrefix: '/proxy/',
  geonamesUser: env.geonamesUser ?? '',
  default_layers: [
    new Tile({
      properties: {
        title: 'OpenStreetMap',
        base: true,
        removable: false,
      },
      source: new OSM({
        url: 'https://cartodb-basemaps-{a-d}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
        attributions: [
          '© <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors,',
          '<a href="https://carto.com/attributions">CARTO</a>',
        ],
      }),
    }),
  ],
  popUpDisplay: 'hover' as const,
  queryPoint: 'hidden',
  project_name: 'erra/map',
  default_view: new View({
    center: [2433348.3022471312, 7744501.813885343],
    zoom: 3.6,
  }),
  advanced_form: true,
  datasources: [
    /*  {
      title: 'Metadata catalogue',
      url: 'https://polirural-cat.lesprojekt.cz/micka2/csw',
      language: 'eng',
      type: 'micka',
      code_list_url:
        'https://polirural-cat.lesprojekt.cz/micka2/util/codelists.php?_dc=1440156028103&language=eng&page=1&start=0&limit=25&filter=%5B%7B%22property%22%3A%22label%22%7D%5D',
    },*/
  ],
  hostname: {
    default: {
      title: 'Default',
      type: 'default',
      editable: false,
      url: getHostname(),
    },
  },
  panelWidths: {
    default: 450,
    datasource_selector: 450,
  },
  // allowAddExternalDatasets: false,
  panelsEnabled: {
    composition_browser: false,
    feature_crossfilter: false,
    info: false,
    saveMap: false,
    sensors: false,
    tracking: false,
    routing: false,
    permalink: false,
    legend: false,
    feature_table: false,
    draw: false,
  },
  reverseLayerList: true,
  status_manager_url: '/statusmanager/',
  sidebarPosition: 'right',
  sizeMode: 'fullscreen',
  translationOverrides: i18n,
};

export default AppConfig;
